import { AppData } from "@/types/globalTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppsState {
  AppsData: AppData[] | null; 
}

const initialState: AppsState = {
  AppsData: JSON.parse(localStorage.getItem('AppsData') || 'null'), 
};

const AppsSlice = createSlice({
  name: 'Apps',
  initialState,
  reducers: {
    setApps: (state, action: PayloadAction<AppData[]>) => {
      state.AppsData = action.payload;
      localStorage.setItem('AppsData', JSON.stringify(action.payload)); // Serialize `AppsData` as JSON
    },
    clearApps: (state) => {
      state.AppsData = null;
      localStorage.removeItem('AppsData');
    },
  },
});

export const { setApps, clearApps } = AppsSlice.actions;

export default AppsSlice.reducer;